import StoredLayout from '../../layouts/StoredLayout'
import PieChartWidgets from './PieChartWidgets'
export default StoredLayout(PieChartWidgets)



// WEBPACK FOOTER //
// ./src/widgets/pie-chart-widgets/index.js